import { useMemo, useCallback } from "react";
import { getInitialLocation } from "../utils";
import useQueryParams from "../../../../hooks/useQueryParams";

export default function useInitialValues(asset, sameLocation) {
  const params = useQueryParams();
  const shipmentId = params.get("shipmentId");

  const initialLocation = useMemo(
    () => getInitialLocation(undefined, shipmentId),
    [shipmentId]
  );

  const getLocations = useCallback(() => {
    const initialLocations = sameLocation || [initialLocation];

    if (!asset?.rackLocations?.length) {
      return initialLocations;
    }

    if (!shipmentId) {
      return asset.rackLocations;
    }

    const hasShipmentLocations = asset.rackLocations.some(
      location => location.shipment_id === shipmentId
    );

    return hasShipmentLocations
      ? asset.rackLocations
      : [...asset.rackLocations, ...initialLocations];
  }, [asset, initialLocation, shipmentId, sameLocation]);

  const initialValues = useMemo(
    () => ({
      id: asset.id,
      code: asset.assetId,
      deletedQuantity: 0,
      locations: getLocations(),
    }),
    [asset, getLocations]
  );

  return initialValues;
}
